module.exports = __webpack_public_path__ + "static/media/LinkensSphere.166c292b.png";